import { DynamicTable } from '../interfaces';
import { DynamicTableColumn } from './dynamic-table-column';

export class ComparabilitySearchInitialRangeResults implements DynamicTable {
  columns: DynamicTableColumn[];
  data: any[];
}
